import { useNavigate } from 'react-router-dom';
import { IGame } from '../../interfaces';
import Footer from '../footer';
import React, { useEffect, useState } from 'react';
import Loader from '../loader';
import { toast } from 'react-toastify';
import { getGamesData } from '../../stores/games.stores';
import HeaderGames from './header';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { MAIN_PAGE_ART, STATIC_FILES_PATH } from '../../common/constants';
import { setDocumentData } from '../../common/tools';

const FOOTER_CLASS_NAME: string = 'games-footer';


export default function GamesMain(): JSX.Element {
    const [ games, setGames ] = useState<IGame[]>([]);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { language } = i18n;

    useEffect(() => {
        setDocumentData();

        _getGamesData();

        i18n.on('languageChanged', (lng: string) => {
            _getGamesData();
        });

        return () => {
            i18n.off('languageChanged');
        };
    }, []);

    const _getGamesData = (): void => {
        getGamesData().then(res => {
            const gamesData: IGame[] = res?.data;

            if (gamesData.length) {
                setGames(gamesData);
            }
        }, err => {
            const errData = err?.response?.data || err;
            console.error({ errData });
            toast.error('GET_GAMES_DATA_ERROR');
        });
    }

    const _renderBox = () => {
        return (
            <div className="games-list">
                {
                    games.map((game: IGame, index: number) => {
                        const { project, mainData } = game;

                        const {
                            cardBackgroundColor,
                            cardLogoImage,
                            name,
                            cardDescription,
                            footerBackgroundColor,
                            inDevelop,
                        } = getGameData(game, index);

                        return (
                            <div
                                key={`${project}_${index}`}
                                className="games-list-item"
                                onClick={() => !inDevelop ? _openGame(mainData?.projectName) : null}
                                style={{ filter: !inDevelop ? 'none' : 'grayscale(0.8)' }}
                            >
                                <div className="games-list-item-image" style={{ background: cardBackgroundColor }}>
                                    <div className="games-list-item-image-block">
                                        <img className="games-list-item-img-game" alt="" src={cardLogoImage}/>
                                    </div>
                                </div>
                                <div className="games-list-item-box" style={{ background: footerBackgroundColor }}>
                                    <div className="games-list-item-name" style={{ color: cardBackgroundColor }}>
                                        { name }
                                    </div>
                                    <div className="games-list-item-description">
                                        { cardDescription }
                                    </div>
                                    <div className="games-list-item-button">
                                        <div
                                            className="games-list-item-button-elem"
                                            style={{ background: !inDevelop ? '#28d223' : '#d1d1d0' }}
                                        >
                                            { !inDevelop ? t('games.buttonPlay') : t('games.buttonInDevelop')  }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    const getGameData = (game: IGame, index: number) => {
        const { web_page, localization } = game;

        const cardBackgroundColor = web_page?.cardBackgroundColor || 'rgba(128, 224, 84, 0.5)';
        const cardLogoImage = `${STATIC_FILES_PATH}${web_page?.cardLogoImage}`;
        const name = localization?.name || `Game_${index + 1}`;
        const cardDescription = localization?.cardDescription || '';
        const footerBackgroundColor = web_page?.footerBackgroundColor || '#f3f4f8';
        const inDevelop = Boolean(web_page?.inDevelop)

        return {
            cardBackgroundColor,
            cardLogoImage,
            name,
            cardDescription,
            footerBackgroundColor,
            inDevelop,
        }
    }

    const _openGame = (projectName: string): void => {
        const path = `/games/${language}/${projectName}/`;
        navigate(path);
    }

    if (!games.length) {
        return <Loader/>
    }

    return (
        <div className="games">
            <div className="games-block">
                <HeaderGames isGame={false}/>
                <div className="games-block-main-art">
                    <img className="games-header-logo-img" alt="" src={MAIN_PAGE_ART}/>
                </div>
                {_renderBox()}
                <Footer className={FOOTER_CLASS_NAME}/>
            </div>
        </div>
    );
}